import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Seurantalinkit',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google-yritystili',
    [UtmSource.SocialMedia]: 'Sosiaalinen media',
  },
  form: {
    utm_source: {
      label: 'Lähde',
      placeholder: 'Valitse lähde',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google-yritystili',
        [UtmSource.SocialMedia]: 'Muu sosiaalinen media',
        [CustomUtmSource.Other]: 'Muu',
      },
    },
    utm_source_details: {
      label: 'Mukautettu lähde',
      placeholder: 'Syötä lähde',
    },
    target_product: {
      label: 'Kohde',
      placeholder: 'Valitse kohde',
    },
    target_url: {
      label: 'Kohde-URL',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Media',
      placeholder: 'Syötä media',
    },
    utm_campaign: {
      label: 'Kampanja',
      placeholder: 'Syötä kampanja',
    },
  },
  fields: {
    utm_source: 'Lähde',
    target_product: 'Kohde',
    type: 'Tyyppi',
    utm_medium: 'Media',
    utm_campaign: 'Kampanja',
    utm_referrer_id: 'Viittaajan tunnus',
  },
  buttons: {
    create_auto_links: 'Luo automaattiset linkit',
    create_link: 'Luo linkki',
    create: 'Luo',
    update: 'Päivitä',
    copy_link: 'Kopioi linkki',
    download_qr_code: 'Lataa QR-koodi',
    edit: 'Muokkaa',
  },
  modals: {
    auto_links_creation: {
      title: 'Oletko varma?',
      description:
        'Varmista, että olet viimeistellyt kaupan asetukset (verkkokaupan aliverkkotunnus / Storefrontin verkkotunnus). Niiden muuttaminen linkkien luomisen jälkeen ei päivity automaattisesti olemassa oleviin linkkeihin!',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
    link_got_copied: 'Linkki kopioitu!',
    failed_to_download_qr_code: 'QR-koodin lataaminen epäonnistui',
  },
};
